// basis-theory.service.ts
import { Injectable } from '@angular/core';

declare const basistheory: any; // Declare the global object from CDN

// DRY: common style options for all elements
export const COMMON_STYLE = {
  fonts: [
    'https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap',
  ],
  base: {
    color: 'black',
    fontWeight: 500,
    fontSize: '16px',
    fontSmooth: 'antialiased',
    '::placeholder': { color: '#6b7294' },
    ':disabled': { backgroundColor: '#f0f0f4' },
  },
  invalid: { color: 'red' },
  complete: { color: 'black' },
  empty: {},
};

@Injectable()
export class BasisTheoryService {
  private btInstance?: any;
  COMMON_STYLE: any = COMMON_STYLE;

  async initialize(apiKey: string): Promise<any> {
    if (!this.btInstance) {
      this.btInstance = await basistheory(apiKey);
      if (!this.btInstance) {
        throw new Error('Basis Theory failed to initialize.');
      }
    }
    return this.btInstance;
  }
}
